import { Button, Tag, Tooltip } from 'antd'
import withKeyValue from '../../../elements/HOC/WithKeyValue'
import withSort from '../../../elements/HOC/withSort'
import CustomSelect from '../../../elements/Select/CustomSelect'
import OrganisationsSelect from '../../../elements/Select/Organistaions'
import withData from '../../../elements/Select/withData'
import DateCell from '../../../elements/Table/Cells/DateCell'
import MoneyCell from '../../../elements/Table/Cells/MoneyCell'
import StatusCell from '../../../elements/Table/Cells/StatusCell'
import CustomTable from '../../../elements/Table/CustomTable'
import SumFooter from '../../../elements/Table/Footers/SumFooter'
import { get, isEmpty, uniq } from 'lodash'
import { dateFormat, formatQueryParams } from '../../../modules/Utils'
import moment from 'moment'
import React from 'react'
import { Link, withRouter } from 'react-router-dom'
import { compose } from 'recompose'
import BoolCell from '../../../elements/Table/Cells/BoolCell'

let globalFiltered = []
export const flagsColumn = {
  Header: 'Flags',
  accessor: 'urgent',
  width: 150,
  Cell: ({ value, original }) => (
    <>
      {get(original, 'paid') !== 0 && get(original, 'paid') === get(original, 'subTotal.gross') ? (
        <Tag color={'#48c94c'}>Paid</Tag>
      ) : (
        <>
          {value === true && <Tag color={'red'}>Urgent</Tag>}
          {get(original, 'scheduledDate') && (
            <Tooltip title={dateFormat(moment(get(original, 'scheduledDate')))}>
              <Tag color={'#ff9909'}>Scheduled</Tag>{' '}
            </Tooltip>
          )}
        </>
      )}
    </>
  ),
}

function getStatusSelect (list) {
  return compose(withData({ data: uniq(list.map((l) => l.status)) }), withKeyValue(), withSort)(CustomSelect)
}

function getPaymentStatusSelect (list) {
  return compose(withData({ data: uniq(list.map((l) => l.paymentStatus)) }), withKeyValue(), withSort)(CustomSelect)
}

function filterArraySelect (filter, row) {
  if (isEmpty(filter.value)) return true
  return filter.value.includes(row[filter.id])
}

function VouchersList (props) {
  const { list, fetch, fetching, company, onChangeCompany, requisitionID } = props
  const StatusSelect = React.useMemo(() => getStatusSelect(list), [list.length])
  const PaymentStatusSelect = React.useMemo(() => getPaymentStatusSelect(list), [list.length])

  const columns = [
    { Header: 'ID', accessor: '_id', width: 100, hideable: true, hideDefault: true },
    {
      Header: 'Code',
      accessor: 'code',
      width: 150,
      Cell: ({ value, original }) => (
        <Link
          to={{
            pathname: `/purchasing/vouchers/${original._key}/update`,
          }}>
          {value}
        </Link>
      ),
    },
    { Header: 'Claim Date', accessor: 'billDate', Cell: DateCell, width: 100 },
    {
      Header: 'Due Date',
      accessor: 'dueDate',
      Cell: DateCell,
      width: 100,
      hideDefault: false,
      hideable: true,
    },
    { Header: 'Doc Ref (No)', accessor: 'no', width: 180, hideable: true },
    {
      Header: 'Cost Category',
      accessor: 'center.category',
      width: 180,
      hideable: true,
      hideDefault: true,
    },
    {
      Header: 'Cost Center',
      accessor: 'center.name',
      width: 180,
      hideable: true,
      hideDefault: true,
    },
    {
      Header: 'Voucher Date',
      accessor: 'date',
      Cell: DateCell,
      hideDefault: true,
      hideable: true,
      width: 100,
    },
    {
      Header: 'Vendor',
      accessor: 'payee.fn',
      width: 200,
      style: { paddingLeft: 20, alignment: 'left' },
    },
    {
      Header: 'Type',
      accessor: 'type',
      width: 130,
      hideDefault: true,
      hideable: true,
    },
    {
      Header: 'Order',
      accessor: 'orders',
      Cell: ({ value, original }) => (
        <Link
          to={{
            pathname: original.orders?.[0]?._id ?
              `purchasing/Order/${original.orders?.[0]?._id.replace('purchases/','')}/update` : ''
            //pathname: `/purchasing/Order/${original.orders[0]._id.replace('purchases/','')}/update`,
          }}>
          {value && value.length === 1 && value[0] !== null ? value[0].code : value && value.length > 1 ? 'Multiple' : 'N/A'}
        </Link>
      ),
      width: 100,
      hideDefault: false,
      hideable: true,
    },
    {
      Header: 'Title',
      accessor: 'title',
      hideDefault: true,
      hideable: true,
    },
    {
      Header: 'Contract',
      accessor: 'contract.code',
      hideDefault: true,
      hideable: true,
    },
    {
      Header: 'Company',
      accessor: 'company.fn',
      width: 300,
      hideDefault: true,
      hideable: true,
    },
    {
      Header: 'PayPlan ID',
      accessor: 'paymentPlan._id',
      hideable: true,
      hideDefault: true,
    },
    {
      Header: 'Bank',
      accessor: 'bank.accname',
      hideDefault: true,
      hideable: true,
    },
    { Header: 'Currency', accessor: 'currency', width: 100 },
    {
      Header: 'Amount (Net)',
      accessor: 'subTotal.net',
      width: 130,
      style: { textAlign: 'right' },
      Cell: MoneyCell,
      Footer: SumFooter,
      hideDefault: true,
      hideable: true,
    },
    {
      Header: 'Amount (Tax)',
      accessor: 'subTotal.tax',
      width: 130,
      style: { textAlign: 'right' },
      Cell: MoneyCell,
      Footer: SumFooter,
      hideDefault: true,
      hideable: true,
    },
    {
      Header: 'Amount (Gross)',
      accessor: 'subTotal.gross',
      width: 130,
      style: { textAlign: 'right' },
      Cell: MoneyCell,
      Footer: SumFooter,
    },
    {
      Header: 'Paid',
      accessor: 'paid',
      width: 130,
      style: { textAlign: 'right' },
      Cell: MoneyCell,
      Footer: SumFooter,
    },
    flagsColumn,
    {
      Header: 'Scheduled Date',
      accessor: 'scheduledDate',
      width: 100,
      Cell: DateCell,
      hideDefault: true,
      hideable: true,
    },
    {
      Header: 'Payment Status',
      accessor: 'paymentStatus',
      width: 130,
      hideDefault: true,
      hideable: true,
      Cell: StatusCell,
      filterMethod: filterArraySelect,
      Filter: ({ onChange, filter }) => (
        <PaymentStatusSelect
          showSearch={false}
          onChange={(value) => {
            onChange(value)
          }}
          value={filter ? filter.value : []}
          mode="multiple"
        />
      ),
    },
    {
      Header: 'Tax Filed',
      accessor: 'taxFiled',
      width: 100,
      Cell: BoolCell,
      hideDefault: true,
      hideable: true,
    },
    {
      Header: 'Status',
      accessor: 'status',
      width: 150,
      Cell: StatusCell,
      filterMethod: filterArraySelect,
      Filter: ({ onChange, filter }) => (
        <StatusSelect
          showSearch={false}
          onChange={(value) => {
            onChange(value)
          }}
          value={filter ? filter.value : []}
          mode="multiple"
        />
      ),
    },
    /*{Header: 'File', accessor: 'file', Cell: FileCell},*/
  ]
  const [filtered, setFiltered] = React.useState(globalFiltered)

  return (
    <CustomTable
      data={list}
      defaultPageSize={20}
      isFilterable={true}
      fetching={fetching}
      fetch={fetch}
      filtered={filtered}
      onFilteredChange={(f, column) => {
        setFiltered(f)
        globalFiltered = f
      }}
      defaultFiltered={globalFiltered}
      ExtraOptionsButtons={() => (
        <OrganisationsSelect
          value={company}
          onChange={onChangeCompany}
          placeholder={'Filter by a company'}
          size={'small'}
          style={{ width: '450px', paddingRight: 20, float: 'right' }}
        />
      )}
      CreateButton={() => (
        <Button
          type={'primary'}
          size="small"
          icon={'plus'}
          onClick={() => {
            props.history.push({
              pathname: '/purchasing/vouchers/new/',
              search: formatQueryParams('requisitionID', requisitionID, true),
            })
          }}>
          New
        </Button>
      )}
      columns={columns}
      show={{
        csv: {
          fileName: 'Vouchers',
        },
      }}
    />
  )
}

export default withRouter(VouchersList)
